import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './SidebarHeader.css';
import notificationsApi from '../../services/notifications';

const SidebarHeader = ({ title, titleClassName = '', hideTitle = false, onOpenLeftSidebar, onOpenRightSidebar }) => {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user?.username) {
      setUnreadCount(0);
      return;
    }

    let cancelled = false;

    const fetchUnreadCount = async () => {
      try {
        const count = await notificationsApi.unreadCount(user.username);
        if (!cancelled) {
          setUnreadCount(Number(count) || 0);
        }
      } catch (_err) {
        if (!cancelled) {
          setUnreadCount(0);
        }
      }
    };

    fetchUnreadCount();
    const intervalId = setInterval(fetchUnreadCount, 15000);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [user?.username]);

  return (
    <div className="sidebar-header-bar">
      <button 
        className="menu-open-btn left-toggle"
        onClick={onOpenLeftSidebar}
        aria-label="Open left menu"
        title="Open menu"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </button>
      
      {!hideTitle && <h2 className={`header-title ${titleClassName}`.trim()}>{title}</h2>}
      
      <button 
        className="menu-open-btn right-toggle"
        onClick={onOpenRightSidebar}
        aria-label="Open user menu"
        title="Open profile menu"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        {unreadCount > 0 && (
          <span className="sidebar-header-badge">{unreadCount}</span>
        )}
      </button>
    </div>
  );
};

export default SidebarHeader;
